import {
    FieldError,
    UseFormClearErrors,
    UseFormRegister,
    UseFormSetError,
    UseFormSetValue,
} from 'react-hook-form';
import { FormInput } from '../BriefForm';
import { Input as BooleanField } from '../FormFields/BooleanField/BooleanField';
import { Input as ClientConfiguredField } from '../FormFields/ClientConfiguredField';
import { Input as DateField } from '../FormFields/DateField/DateField';
import { Input as FilesField } from '../FormFields/FilesField';
import { Input as GridChoiceField } from '../FormFields/GridChoiceField/GridChoiceField';
import { Input as InputField } from '../FormFields/InputField';
import { Input as IntelligentStylesField } from '../FormFields/IntelligentStylesField/IntelligentStylesField';
import { Input as MultiChoiceField } from '../FormFields/MultiChoiceField/MultiChoiceField';
import { Input as MultiGridChoiceField } from '../FormFields/MultiGridChoiceField/MultiGridChoiceField';
import { Input as MultiInputField } from '../FormFields/MultiInputField';
import { Input as RadioChoiceField } from '../FormFields/RadioChoiceField/RadioChoiceField';
import { Input as SelectChoiceField } from '../FormFields/SelectChoiceField/SelectChoiceField';
import { Input as TextAreaField } from '../FormFields/TextAreaField';
import { WorkEntityField } from '../FormFields/WorkEntityField';
import { FieldFragment } from '../brief.generated';

type FieldInputProps = {
    field: FieldFragment;
    register: UseFormRegister<FormInput>;
    setValue: UseFormSetValue<FormInput>;
    clearErrors: UseFormClearErrors<FormInput>;
    setError: UseFormSetError<FormInput>;
    error?: FieldError | undefined;
};

export default function FieldInput({
    field,
    register,
    setValue,
    clearErrors,
    setError,
    error,
}: FieldInputProps) {
    switch (field.__typename) {
        case 'InputField':
            return (
                <InputField
                    {...field}
                    register={register}
                    setValue={setValue}
                    clearErrors={clearErrors}
                    errorMsg={error?.message}
                />
            );
        case 'TextAreaField':
            return (
                <TextAreaField
                    {...field}
                    register={register}
                    setValue={setValue}
                    clearErrors={clearErrors}
                />
            );
        case 'MultiChoiceField':
            return <MultiChoiceField {...field} register={register} setValue={setValue} />;
        case 'RadioChoiceField':
            return <RadioChoiceField {...field} register={register} setValue={setValue} />;
        case 'MultiInputField':
            return (
                <MultiInputField
                    {...field}
                    register={register}
                    setValue={setValue}
                    clearErrors={clearErrors}
                />
            );
        case 'FilesField':
            return <FilesField {...field} register={register} setValue={setValue} />;
        case 'MultiGridChoiceField':
            return (
                <MultiGridChoiceField
                    {...field}
                    register={register}
                    setValue={setValue}
                    clearErrors={clearErrors}
                    setError={setError}
                />
            );
        case 'ClientConfiguredField':
            return (
                <ClientConfiguredField
                    {...field}
                    register={register}
                    setValue={setValue}
                    clearErrors={clearErrors}
                    error={error}
                />
            );
        case 'WorkEntityField':
            return <WorkEntityField {...field} />;
        case 'SelectChoiceField':
            return <SelectChoiceField {...field} register={register} setValue={setValue} />;
        case 'GridChoiceField':
            return <GridChoiceField {...field} register={register} setValue={setValue} />;
        case 'DateField':
            return (
                <DateField
                    {...field}
                    register={register}
                    setValue={setValue}
                    clearErrors={clearErrors}
                />
            );
        case 'IntelligentStylesField':
            return (
                <IntelligentStylesField
                    {...field}
                    register={register}
                    setValue={setValue}
                    clearErrors={clearErrors}
                    setError={setError}
                    error={error}
                />
            );
        case 'BooleanField':
            return (
                <BooleanField
                    {...field}
                    register={register}
                    setValue={setValue}
                    clearErrors={clearErrors}
                />
            );
        default:
            return <div>{field.__typename} not yet implemented</div>;
    }
}
